import { routes } from "utilities/routes";

import { TemplateListTabs } from "entity/template/TemplateList/TemplateListTab/TemplateListTab.api.types";

export const jobPickerModeParam = "jobPickerMode";
export const templateModeParamValue = "template";
/** Accepted by `applyJobPickerModeFromUrl` for future callers. No link builder emits it yet. */
export const jobModeParamValue = "job";

/**
 * The link that opens a template with the job picker in template mode and that template selected.
 * The mode rides on the URL, not in storage, so a new tab can start in template mode without
 * touching the job picker state of the tab that opened it.
 */
export function getOpenTemplateUrl(templateId: number): string {
    const selectTemplateUrl = routes.jobPicker.selectJobLink(
        templateId,
        routes.template.getListLink(TemplateListTabs.SelectedTemplate),
    );
    return `${selectTemplateUrl}&${jobPickerModeParam}=${templateModeParamValue}`;
}
